var _g, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrans(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 56,
    viewBox: "0 0 52 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1525_14944)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46 19.9401C46 12.1339 46 10.5347 44.2875 7.70176C43.3031 6.07335 41.9422 4.7072 40.32 3.71906C37.4978 2 33.6652 2 26 2C18.3348 2 14.5023 2 11.6801 3.71906C10.0579 4.7072 8.69687 6.07335 7.71252 7.70176C6 10.5347 6 12.078 6 19.7725V29.8108C6 35.3546 10.4771 39.8488 16 39.8488V42.3056C16 44.4443 16 45.5138 16.6859 45.8874C17.3715 46.2613 18.265 45.6787 20.0518 44.5137L26.1967 40.5071C34.0328 40.2467 37.9508 40.1165 40.7497 38.241C42.1515 37.3017 43.3366 36.072 44.2253 34.6347C46 31.7645 46 27.8231 46 19.9401Z",
    fill: "#1891FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6859 45.8874C16 45.5138 16 44.4443 16 42.3056V40.3488L16.6859 45.8874ZM16.6859 45.8874C17.3715 46.2613 18.265 45.6787 20.0518 44.5137L26.1967 40.5071L16.6859 45.8874ZM16 39.3488H16.5V39.8488V42.3056C16.5 43.3919 16.5013 44.1493 16.5804 44.6855C16.6593 45.2207 16.7944 45.3772 16.9251 45.4484L16.9252 45.4484C17.055 45.5192 17.2578 45.548 17.7472 45.3233C18.2378 45.0979 18.871 44.6867 19.7787 44.0948L25.9236 40.0883L26.0405 40.012L26.1801 40.0074C30.1079 39.8769 33.0183 39.7796 35.2978 39.4839C37.5699 39.1891 39.1627 38.7026 40.4714 37.8256C41.8137 36.9261 42.9488 35.7484 43.8001 34.3718C44.6301 33.0293 45.0621 31.4129 45.2804 29.1198C45.4995 26.8195 45.5 23.8913 45.5 19.9401C45.5 16.0212 45.499 13.7086 45.2897 12.0173C45.0852 10.365 44.6836 9.32355 43.8596 7.96042C42.9167 6.40068 41.6133 5.09232 40.0598 4.14607C38.7402 3.34223 37.1616 2.92408 34.929 2.71266C32.689 2.50052 29.8423 2.5 26 2.5C22.1577 2.5 19.3111 2.50052 17.0711 2.71266C14.8385 2.92408 13.2599 3.34223 11.9402 4.14608C10.3868 5.09232 9.08326 6.40069 8.14041 7.96042C7.31534 9.32529 6.91434 10.3532 6.71016 11.9764C6.50101 13.6391 6.5 15.9092 6.5 19.7725V29.8108C6.5 35.0802 10.7551 39.3488 16 39.3488Z",
    stroke: "#0068C7"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.0001 18.5C31.5112 18.5 31.9709 18.8113 32.1607 19.2858L37.1607 31.7857C37.4171 32.4267 37.1054 33.1542 36.4644 33.4106C35.8234 33.667 35.0959 33.3553 34.8395 32.7143L33.2789 28.8125H28.7214L27.1607 32.7143C26.9044 33.3553 26.1769 33.667 25.5359 33.4106C24.8949 33.1542 24.5831 32.4267 24.8395 31.7857L29.8395 19.2858C30.0294 18.8113 30.489 18.5 31.0001 18.5ZM29.7214 26.3125H32.2789L31.0001 23.1158L29.7214 26.3125Z",
    fill: "#F0F6FD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.3375 9.93992C20.9229 9.57404 21.6941 9.75201 22.06 10.3374L23.2553 12.2499H27.25C27.9404 12.2499 28.5 12.8096 28.5 13.4999C28.5 14.1903 27.9404 14.7499 27.25 14.7499H25.0725C24.5505 16.4435 23.6442 18.5987 22.3365 20.4668C22.3149 20.4977 22.2931 20.5285 22.2712 20.5593C23.2606 21.4834 24.5148 22.1218 26.1038 22.2543C26.7917 22.3115 27.303 22.9158 27.2456 23.6038C27.1884 24.2917 26.5841 24.8029 25.8962 24.7457C23.6908 24.5618 21.9667 23.6677 20.6436 22.4574C19.2534 23.7793 17.5018 24.7499 15.375 24.7499C14.6846 24.7499 14.125 24.1903 14.125 23.4999C14.125 22.8095 14.6846 22.2499 15.375 22.2499C16.7148 22.2499 17.9339 21.6178 19.0171 20.5553C18.9053 20.3897 18.7984 20.2222 18.6964 20.0537C17.6148 18.2674 17.0277 16.2959 16.7696 14.7499H14.75C14.0597 14.7499 13.5 14.1903 13.5 13.4999C13.5 12.8096 14.0597 12.2499 14.75 12.2499H20.3072L19.94 11.6624C19.5741 11.077 19.7521 10.3058 20.3375 9.93992ZM22.4396 14.7499H19.3113C19.5377 15.8725 19.9652 17.2218 20.6646 18.4667C21.4322 17.2496 22.0261 15.9193 22.4396 14.7499Z",
    fill: "#F0F6FD"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1525_14944",
    x: 0,
    y: 0,
    width: 52,
    height: 56,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0941176 0 0 0 0 0.565176 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1525_14944"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1525_14944",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrans);
export default __webpack_public_path__ + "static/media/trans.cabb3cd7191352d4618076fff1b0fda0.svg";
export { ForwardRef as ReactComponent };